import * as React from "react";
import PropTypes from "prop-types";
import {
  TreeGridComponent,
  ColumnsDirective,
  ColumnDirective,
  Selection,
  Inject,
  Sort,
  Filter,
  ColumnChooser,
  Toolbar,
  Edit,
  Resize,
  RowDD,
  Freeze,
  ExcelExport,
  ColumnMenu,
} from "@syncfusion/ej2-react-treegrid";
import { useRef, useState, useEffect } from "react";
import { IoMdFunnel } from "react-icons/io";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";

function TreeDataGrid(props) {
  const {
    columnFields,
    fetch,
    showGridToolBar = true,
    height,
    rowDataBound = () => {
      return;
    },
    showBottomBorder = false,
    showResetFilter = false,
    childMapping = "",
    getGridRef = undefined,
    functionClick = undefined,
    dataBound = undefined,
    showExportButton = false,
    defaultSortingOptions = {},
    showLoader = () => {
      return;
    },
    hideLoader = () => {
      return;
    },
    exportFileName = "Client Activity Tracker",
  } = props;
  const sideNavActiveState = useSelector((state) => state.sideNavState.active);
  const gridRef = useRef(null);
  const [rowData, setRowData] = useState([]);

  if (getGridRef) {
    getGridRef(gridRef);
  }

  function handleColumnChooser(args) {
    const button = args.currentTarget;
    const buttonRect = button.getBoundingClientRect();
    const middleX = buttonRect.left + buttonRect.width / 2;
    const offsetX = middleX - (sideNavActiveState ? 260 : 248);
    gridRef.current.columnChooserModule.openColumnChooser(offsetX, 0);
  }

  const handleResetFilters = () => {
    gridRef.current.clearFiltering();
    gridRef.current.clearSelection();
    gridRef.current.clearSorting();
  };
  const handleExportData = () => {
    let excelExportProperties = {
      fileName: `${exportFileName}.xlsx`,
    };
    gridRef.current.excelExport(excelExportProperties);
  };

  const handleDataBound = () => {
    dataBound && dataBound();
    setIconAlignment();
    clearLocalGrid();
  };

  const clearLocalGrid = () => {
    // Iterate over localStorage and insert the keys that meet the condition into arr
    const arr = [];
    for (let i = 0; i < localStorage.length; i++) {
      if (localStorage.key(i).substring(0, 8) == "gridgrid") {
        arr.push(localStorage.key(i));
      }
    }
    for (let i = 0; i < arr.length; i++) {
      localStorage.removeItem(arr[i]);
    }
  };

  const handleActionComplete = (args) => {
    if (args.requestType === "refresh" || args.requestType === "filtering") {
      let dataResults = gridRef.current.dataResults.result;
      let movablescrollbar = gridRef.current.element?.querySelector(".e-movablescrollbar");
      let frozenContent = gridRef.current.element?.querySelector(".e-grid .e-frozencontent.e-frozen-left-content");
      let frozenborder = frozenContent?.querySelector(".e-table");
      if (dataResults.length > 0) {
        if (frozenContent) frozenContent.style.width = "min-content";
        if (frozenborder) frozenborder.style.borderRight = "2px solid #6c757d";
        if (movablescrollbar) movablescrollbar.style.display = "block";
      }
      if (args.requestType === "filtering" && dataResults.length == 0) {
        showNoRecordFound(true);
      }
    }
    setIconAlignment();
    // to reve the existing operator and add the required operator
    if (args.columnType === "string") {
      var dropdownInstance = args.filterModel.dlgDiv.getElementsByClassName("e-dropdownlist")[0];
      if (args.requestType === "filterafteropen" && dropdownInstance) {
        if (["subscriptionProductType", "subscriptionType"].includes(args.columnName)) {
          args.filterModel.dlgObj.element.children[0].firstElementChild.children[0].style.display = "none";
        }
        dropdownInstance.ej2_instances[0].dataSource = [
          {
            value: "startswith",
            text: "Starts With",
          },
          {
            value: "endswith",
            text: "Ends With",
          },
          {
            value: "contains",
            text: "Contains",
          },
          {
            value: "equal",
            text: "Equal",
          },
          {
            value: "notequal",
            text: "Not Equal",
          },
        ];
      }
    }
  };

  function setIconAlignment() {
    const gridinstances = document.querySelector(".e-grid");
    const instancesNew = gridinstances && gridinstances.ej2_instances[0];
    const headercells = instancesNew && instancesNew.element.querySelectorAll(".e-headercell");
    for (let i = 0; i < headercells?.length; i++) {
      if (headercells[i].querySelector(".e-headertext")) {
        var headertextwidth = headercells[i].querySelector(".e-headertext").getBoundingClientRect().width;
        var headercelldivwidth = headercells[i].querySelector(".e-headercelldiv").getBoundingClientRect().width;
        let rightSortFiltermargin = 0;
        let distance = 10;
        let rightFilterMargin = 0;
        let sortIconWidth = 16;
        let headercellPaddingRight = 10;
        let headercellPaddingLeft = 10;
        if (headercells[i].classList.contains("e-leftalign")) {
          rightSortFiltermargin = headercelldivwidth - headertextwidth - (distance * 2 + headercellPaddingRight + headercellPaddingLeft);
          rightFilterMargin = headercelldivwidth - headertextwidth - (sortIconWidth + distance * 2 + headercellPaddingLeft + headercellPaddingLeft);
        }
        if (headercells[i].classList.contains("e-centeralign")) {
          rightSortFiltermargin = (headercelldivwidth - headertextwidth) / 2 - (sortIconWidth + distance);
          rightFilterMargin = (headercelldivwidth - headertextwidth) / 2 - (15 + sortIconWidth + distance);
        }
        if (headercells[i].classList.contains("e-rightalign")) {
          rightSortFiltermargin = headercelldivwidth - headertextwidth - (sortIconWidth + distance);
          rightFilterMargin = 2;
        }
        // change the filtericon margin

        if (headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter")) {
          // change the filter icon position
          if (headercells[i].classList.contains("e-rightalign")) {
            headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter").style.margin = "-21px " + 16 + "px" + " -18px 0px";
          } else if (headercells[i].classList.contains("e-leftalign")) {
            headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter").style.margin = "-21px " + rightFilterMargin + "px" + " -18px 0px";
          } else {
            headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter").style.margin = "-21px " + rightFilterMargin + "px" + " -18px 0px";
          }
          headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter").style.padding = "6px 0px 6px 0px";
          headercells[i].querySelector(".e-filtermenudiv.e-icons.e-icon-filter").style.display = "block";
        }

        // change the sorticon margin
        if (headercells[i].querySelector(".e-sortfilterdiv.e-icons")) {
          // change the Sort icon position
          headercells[i].querySelector(".e-sortfilterdiv.e-icons").style.margin = "-23px " + rightSortFiltermargin + "px" + " -15px 0px";
        }
        headercells[i].querySelector(".e-sortfilterdiv.e-icons").style.display = "block";
      }
    }
  }

  // Function to show hide No Record Found Text
  const showNoRecordFound = (showNoRecordText) => {
    setTimeout(() => {
      let emptyRow = gridRef?.current?.element.querySelector(".e-gridcontent .e-content .e-emptyrow");
      let frozenContent = gridRef.current.element?.querySelector(".e-grid .e-frozencontent.e-frozen-left-content");
      let frozenborder = frozenContent?.querySelector(".e-table");
      if (!showNoRecordText || !emptyRow) return;
      let emptyRowTD = emptyRow.querySelector("td");
      emptyRow.style.height = "106px";
      emptyRow.style.display = "table-row";
      emptyRowTD.style.display = "";
      emptyRowTD.style.textAlign = "center";
      emptyRowTD.innerText = "No Records Found";
      if (frozenborder) frozenborder.style.borderRight = "none";
      if (frozenContent) frozenContent.style.width = "max-content";
    }, 100);
  };

  /**
   * @description fetch grid data for first time, also when filters & sort changes
   */
  const fetchGridData = () => {
    if (gridRef?.current) {
      let frozencontent = gridRef.current.element?.querySelector(".e-gridcontent .e-content .e-emptyrow td");
      if (gridRef?.current?.dataResults?.result?.length === 0) frozencontent.innerText = "";
    }
    const params = {};
    showLoader();
    fetch(params)
      .then(async (res) => {
        setRowData(res?.data?.data);
        if (gridRef?.current?.clearRowSelection) gridRef.current.clearRowSelection();
        res?.data?.data.length === 0 ? showNoRecordFound(true) : showNoRecordFound(false);
        hideLoader();
      })
      .catch(() => {
        hideLoader();
        showNoRecordFound(true);
      });
  };

  const cleanUpFilters = () => {
    gridRef.current.clearFiltering();
    gridRef.current.clearSorting();
  };

  useEffect(() => {
    cleanUpFilters();
  }, []);

  useEffect(() => {
    cleanUpFilters();
    fetchGridData();
  }, [functionClick]);

  return (
    <div className="gridPanel">
      {showGridToolBar && (
        <nav className="navbar navbar-dark bg-dark rounded-top ">
          <div className="form-inline my-2 my-lg-0  " style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <div>
              {showExportButton && (
                <button
                  className="btn btn-outline-white active mr-sm-2 btn-sm action-button "
                  id="dataScreeningExport"
                  onClick={(e) => handleExportData()}
                >
                  <i className="fas fa-download pr-1"></i>Export
                </button>
              )}
            </div>
            <div>
              {showResetFilter && (
                <button className="btn btn-outline-white active mr-sm-2 btn-sm  btn-dark " id="clearFilter" onClick={() => handleResetFilters()}>
                  <i className=" pr-1">
                    <IoMdFunnel />
                  </i>
                  Reset Filters
                </button>
              )}
              <button className="btn btn-outline-white active  btn-sm btn btn-dark" id="openColumnChooser" onClick={(e) => handleColumnChooser(e)}>
                <i className="fa fa-columns pr-1"></i>Column Chooser
              </button>
            </div>
          </div>
        </nav>
      )}
      {rowData && (
        <div className="treegrid-root">
          <TreeGridComponent
            ref={gridRef}
            dataSource={rowData}
            gridLines="Both"
            treeColumnIndex={0}
            childMapping={childMapping}
            allowSorting={true}
            sortSettings={defaultSortingOptions}
            allowFiltering={true}
            allowExcelExport={true}
            allowSelection={false}
            filterSettings={{ type: "Menu", hierarchyMode: "Both" }}
            showColumnChooser
            height={height || "100%"}
            rowDataBound={rowDataBound}
            enableCollapseAll={true}
            actionComplete={handleActionComplete}
            loadingIndicator={{ indicatorType: "Spinner" }}
            dataBound={handleDataBound}
            clipMode="EllipsisWithTooltip"
            style={{
              height: "100%",
              maxHeight: "100%",
              maxWidth: "100%",
              overflowY: "auto",
              overflowX: "auto",
              borderBottom: showBottomBorder ? "1px solid rgba(209,213,219,0.5)" : "none",
            }}
          >
            <ColumnsDirective>
              {columnFields.map((cN, i) => (
                <ColumnDirective
                  key={"cD" + i}
                  field={cN.field}
                  headerText={cN.headerText ? cN.headerText : cN.field}
                  type={cN.type}
                  filterTemplate={cN.filterTemplate}
                  textAlign={cN.textAlign}
                  headerTextAlign={cN.headerTextAlign}
                  width={cN.width}
                  filter={{ ...cN.filter }}
                  // template={cN.template}
                  columns={cN.columns}
                  isFrozen={cN.isFrozen ?? false}
                  showInColumnChooser={cN.showInColumnChooser ?? false}
                  allowSorting={cN.allowSorting ?? false}
                  allowFiltering={cN.allowFiltering ?? false}
                  headerTemplate={cN.headerTemplate}
                />
              ))}
            </ColumnsDirective>
            <Inject services={[Sort, Filter, Resize, Freeze, Edit, ColumnMenu, Selection, ColumnChooser, Toolbar, RowDD, ExcelExport]} />
          </TreeGridComponent>
        </div>
      )}
    </div>
  );
}

TreeDataGrid.propTypes = {
  fetch: PropTypes.func.isRequired,
  showLoader: PropTypes.func,
  hideLoader: PropTypes.func,
  columnFields: PropTypes.arrayOf(PropTypes.object),
};

TreeDataGrid.defaultProps = {
  fetch: () => {},
  deleteOne: () => {},
  deleteMany: () => {},
  showLoader: () => {},
  hideLoader: () => {},
  columnNames: {},
  columnFields: [{}],
};

export default TreeDataGrid;
